import { render } from "./index.vue?vue&type=template&id=4011c6bd"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=4011c6bd&lang=scss"
script.render = render

export default script